import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <Button variant="ghost" size="sm" asChild className="mb-8">
          <Link to="/">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar
          </Link>
        </Button>

        <h1 className="text-3xl font-bold text-foreground mb-8">
          Política de Privacidade
        </h1>

        <div className="prose prose-sm dark:prose-invert max-w-none space-y-6 text-muted-foreground">
          <p className="text-sm">
            Última atualização: {new Date().toLocaleDateString("pt-BR", { month: "long", year: "numeric" })}
          </p>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">1. Informações que Coletamos</h2>
            <p>
              Coletamos informações que você nos fornece diretamente: nome, e-mail e dados
              financeiros que você registra na plataforma (transações, contas, orçamentos, metas).
              Também coletamos dados de uso como páginas visitadas e funcionalidades utilizadas.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">2. Como Usamos suas Informações</h2>
            <p>
              Usamos seus dados para fornecer e melhorar o serviço, processar pagamentos,
              enviar comunicações sobre sua conta, e gerar relatórios financeiros personalizados.
              Não vendemos seus dados pessoais para terceiros.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">3. Armazenamento e Segurança</h2>
            <p>
              Seus dados são armazenados no Supabase Cloud com criptografia em repouso e em
              trânsito. Utilizamos Row Level Security (RLS) no PostgreSQL para garantir que
              apenas você acesse suas informações. Toda comunicação é protegida por HTTPS/TLS.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">4. Compartilhamento de Dados</h2>
            <p>
              Compartilhamos dados apenas com: Stripe (processamento de pagamentos), Supabase
              (infraestrutura) e quando exigido por lei. A funcionalidade de compartilhamento
              de contas só é ativada por convite direto seu.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">5. Cookies e Rastreamento</h2>
            <p>
              Utilizamos cookies essenciais para autenticação e preferências (como tema claro/escuro).
              Não utilizamos cookies de rastreamento publicitário. Dados de sessão são armazenados
              localmente no navegador.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">6. Seus Direitos (LGPD)</h2>
            <p>
              De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a: acessar
              seus dados, corrigir informações incorretas, excluir sua conta e dados, exportar
              seus dados em formato legível, e revogar consentimento para processamento.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">7. Retenção de Dados</h2>
            <p>
              Mantemos seus dados enquanto sua conta estiver ativa. Ao excluir sua conta, todos
              os dados pessoais e financeiros são removidos permanentemente em até 30 dias.
              Dados de pagamento são retidos pela Stripe conforme suas políticas.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">8. Alterações nesta Política</h2>
            <p>
              Podemos atualizar esta política periodicamente. Notificaremos sobre alterações
              significativas por e-mail. Recomendamos revisar esta página regularmente.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">9. Contato</h2>
            <p>
              Para questões sobre privacidade ou exercer seus direitos, entre em contato pelo
              e-mail{" "}
              <a href="mailto:contato@nextaifinance.com" className="text-primary hover:underline">
                contato@nextaifinance.com
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
